import * as flash from './flash';

document.addEventListener('DOMContentLoaded', function () {
  flash.init();
});
